function isInternetExplorer() {
    const navigator = window.navigator;
    return navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0;
}
function getDeviceHash() {
    const deviceInfo = navigator.userAgent;
    let hash = 0;
    for (let i = 0; i < deviceInfo.length; i++) {
        const char = deviceInfo.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
}
module.exports = {
    isInternetExplorer,
    getDeviceHash
};
